import { render, staticRenderFns } from "./TradingNetworksList.vue?vue&type=template&id=2920db22&scoped=true"
import script from "./TradingNetworksList.vue?vue&type=script&lang=js"
export * from "./TradingNetworksList.vue?vue&type=script&lang=js"
import style0 from "./TradingNetworksList.vue?vue&type=style&index=0&id=2920db22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2920db22",
  null
  
)

export default component.exports